import { render, staticRenderFns } from "./OptionPageNex.vue?vue&type=template&id=be959b8e&scoped=true&"
import script from "./OptionPageNex.vue?vue&type=script&lang=ts&"
export * from "./OptionPageNex.vue?vue&type=script&lang=ts&"
import style0 from "./OptionPageNex.vue?vue&type=style&index=0&id=be959b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be959b8e",
  null
  
)

export default component.exports